import React from 'react'
import classes from './UserProfile.module.css'


const UserProfile = ({ width, image, children }) => {

    return (
        <div>
            <div className={classes.UserImage}
                style={{ backgroundImage: `url(${image})`, width: width, height: width }}>
                {children}
            </div>
        </div>
    )
}

export default UserProfile;